import { CustomSearchBox } from './components/CustomSearchBox';
import { HeaderTitle } from './components/HeaderTitle';
import { SearchQueryResultText } from './components/SearchQueryResultText';

export const Header: React.FC = () => {
	return (
		<div className="mt-4 md:mt-16">
			<HeaderTitle />
			<CustomSearchBox />
			<SearchQueryResultText />
		</div>
	);
};
